<template>
  <header class="admin-header">
    <a href="#" @click.prevent="toggleMenu()" class="admin-header__link">
      <i class="fas fa-bars"></i>
    </a>
    <a href="/" class="admin-header__link">
      <img alt="Quero Pago" :src="require('assets/images/queropago.svg')" class="admin-header__logo">
    </a>
    <a
      class="admin-header__link"
      :href="`${$serverHost}/admin/sign-out`"
      v-if="this.showSignOut === true"
    >
      <span>SAIR</span>
      <i class="fas fa-sign-out-alt admin-header__icon admin-header__icon--spaced"></i>
    </a>
  </header>
</template>

<script>
export default {
  props: {
    showSignOut: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    toggleMenu() {
      this.$emit('menu-toggle');
    },
  },
};
</script>
